export default __webpack_public_path__ + "static/media/navneet-gill-intro-website-bg.a6620a40.jpg";